<template>
  <div class="cardsStatus">
    <div class="card" @click="selectNewstep">
      <div class="card__statusInformation">
        <div class="statusInformation__icon">
          <img :src="icon" alt="status icon">
        </div>
        <div class="statusInformation_textInformation">
          <h2 class="textInformation__title">
            {{ titleCardStatus }}
          </h2>
          <span class="textInformation__subtitle">
            {{ status }}
          </span>
        </div>
      </div>
      <div class="card__arrowForward">
        <img src="../../../public/images/arrow-forward.svg" alt="arrow forward">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      titleCardStatus: {
        type: String,
        required: true
      },
      status: {
        type: String,
        required: true
      },
      selectNewstep: {
        type: Function,
        required: true
      },
      icon: {
        type: String,
        required: true
      }
    },
  };
</script>
<style lang="scss">
    @import "@vuxx/hounds/scss/abstracts/mixins";
    @import "@vuxx/hounds/scss/abstracts/variables";

    .card{
        box-shadow: 0px 4px 15px 0px #0000001A;
        border: none;
        flex-direction: row;
        justify-content: space-between;
        padding: 16px;
        width: 90%;
        height: 85px;
        align-self: center;
        border-radius: 8px;

        @include breakpoint('medium') {
            width: 100%;
        }
    }

    .card__statusInformation{
        display: flex;
        gap: 16px;
        flex-direction: row;
        align-items: center;
    }

    .statusInformation_textInformation{
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .textInformation__title{
        font-size: 16px;
        font-weight: 500;
    }

    .textInformation__subtitle{
        font-size: 14px;
        font-weight: 500;
        color: $color-text-secondary;
    }

    .card__arrowForward{
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>


